import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.updateAllButtonStates();
    this.element.addEventListener('change', (e) => this.handleChange(e));
  }

  handleChange(event) {
    const form = event.target.closest('form');
    if (form) this.updateButtonStateForForm(form);
  }

  updateAllButtonStates() {
    this.element.querySelectorAll('form').forEach((form) => this.updateButtonStateForForm(form));
  }

  updateButtonStateForForm(form) {
    const button = form.querySelector("[type='submit']");
    if (!button) return;

    // Upload form: requires a file to be selected
    const fileInput = form.querySelector("input[type='file']");
    if (fileInput) {
      this.toggleButton(button, fileInput.files.length > 0);
      return;
    }

    // Download form: requires at least one org AND at least one field checked
    const hasOrg = !!form.querySelector("input[name='organization_ids[]']:checked");
    const hasField = !!form.querySelector("input[name^='fields[']:checked");
    this.toggleButton(button, hasOrg && hasField);
  }

  toggleButton(button, enabled) {
    button.toggleAttribute('disabled', !enabled);
    const toggles = [
      ['bg-grey-1', !enabled],
      ['text-grey-4', !enabled],
      ['cursor-not-allowed', !enabled],
      ['bg-tealLight', enabled],
      ['text-white', enabled],
      ['cursor-pointer', enabled],
    ];
    toggles.forEach(([cls, on]) => button.classList.toggle(cls, on));
  }
}
